import { render, staticRenderFns } from "./SchoolProlongationActivityPopup.vue?vue&type=template&id=6509ddbc&scoped=true&lang=pug&"
import script from "./SchoolProlongationActivityPopup.vue?vue&type=script&lang=js&"
export * from "./SchoolProlongationActivityPopup.vue?vue&type=script&lang=js&"
import style0 from "./SchoolProlongationActivityPopup.vue?vue&type=style&index=0&id=6509ddbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6509ddbc",
  null
  
)

export default component.exports